"use client";




export default function Cta() {
  return (
    <section
      id="cta"
      className="flex justify-center border-t border-border relative px-5 md:px-8 lg:px-0 pt-20 pb-10 w-full"
    >
      {/* Main Content Container */}
      <div className="relative z-10 w-full max-w-7xl flex flex-col lg:flex-row items-center gap-12 lg:gap-16 lg:justify-between">
        {/* Image */}
        <div className="w-full lg:w-2/3 flex justify-center lg:justify-between">
          <img
            src="https://img.b2bpic.net/premium-photo/aerial-view-construction-site_1346048-30725.jpg?w=740"
            loading="lazy"
            decoding="async"
            className="w-full max-w-xs md:max-w-sm lg:max-w-md object-cover aspect-[0.9] rounded-md shadow-lg max-h-[18rem]"
            aria-hidden="true"
          />
        </div>

        {/* Content */}
        <div className="w-full flex flex-col items-center lg:items-start text-center lg:text-left">
          <span className="text-primary uppercase text-sm font-semibold mb-4">
            Experienced Builders in Montreal
          </span>
          <h2 className="text-4xl font-bold text-foreground mb-4">
            Ready to Start Your Next Project?
          </h2>
          <p className="text-foreground/80 mb-8">
            Serving residential, commercial, and industrial clients across
            Montreal with quality construction you can trust.
          </p>
          <a
            href="/contact"
            className="w-fit flex justify-center items-center bg-primary text-primary-foreground hover:bg-primary/90 \\\\n px-6 py-3 rounded-md font-bold min-w-[10rem] \\\\n transition-colors duration-300"
          >
            Request a Quote
          </a>
        </div>
      </div>
    </section>
  );
}
